<p>enabledebug works!</p>
